//import badge from react-boostrap and create a function component that create a badge and passes props
import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';

//create functional component that returns a Badge
export const BadgeComponent = (props: any) => {
  return (
    <Badge
      style={{ fontSize: "13px", ...props.style, color: '#fff' }}

      bg={props.variant}
      pill={props.pill}
    >
      {props.badgeTextForDueDate} • {props.date}
    </Badge>
  );
};
